import APIController from '../core-api-controller';

export const fetchTokensListApi = (paramsObj = {}, paramsStr = '') => {
  const path = `${APIController.endpointApi}/external_tokens${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path, paramsObj);
};

export const createTokenApi = (data = {}) => {
  const path = `${APIController.endpointApi}/external_tokens`;
  return APIController.postCallback(path, data);
};

export const updateTokenApi = (tokenId = '', data = {}) => {
  const path = `${APIController.endpointApi}/external_tokens/${tokenId}`;
  return APIController.putCallback(path, data);
};

export const deleteTokenApi = (tokenId = '') => {
  const path = `${APIController.endpointApi}/external_tokens/${tokenId}`;
  return APIController.deleteCallback(path);
};
